import Swiper from "swiper";
import {Navigation, Pagination} from "swiper/modules";

export default class Sliders {
    constructor(world) {
        this.world = world;
        this.containers = document.querySelectorAll(".swiper-container");
        this.sliders = [];

        if (!this.containers) {
            return;
        }

        this.buildSliders();
    }

    updatePopinHeader(container, activeIndex) {
        if (!container) return;

        // Récupération du swiper dans ce container
        const swiperElement = container.querySelector('.swiper');
        if (!swiperElement) return;

        // Récupération de la slide active
        const slides = container.querySelectorAll('.swiper-slide');
        if (!slides || slides.length === 0) return;

        // Vérifie si nous avons un index valide
        const activeSlide = slides[activeIndex] || slides[0];
        if (!activeSlide) return;

        // Récupération de la langue actuelle
        const currentLang = document.body.getAttribute('data-lang') || 'fr';

        // Récupération du titre de la slide selon la langue active
        const titleElement = activeSlide.querySelector(`h2.lang-${currentLang}`);
        if (!titleElement) return;

        // Mise à jour du titre dans le header de la popin pour chaque langue
        const popinHeaderFr = container.querySelector('.popin-header h3.lang-fr');
        const popinHeaderEn = container.querySelector('.popin-header h3.lang-en');
        const popinHeaderDe = container.querySelector('.popin-header h3.lang-de');

        // Récupérer les titres dans chaque langue
        const titleFr = activeSlide.querySelector('h2.lang-fr')?.textContent || "";
        const titleEn = activeSlide.querySelector('h2.lang-en')?.textContent || "";
        const titleDe = activeSlide.querySelector('h2.lang-de')?.textContent || "";

        // Mettre à jour les titres dans chaque langue
        if (popinHeaderFr) popinHeaderFr.textContent = titleFr;
        if (popinHeaderEn) popinHeaderEn.textContent = titleEn;
        if (popinHeaderDe) popinHeaderDe.textContent = titleDe;
    }

    buildSliders() {
        this.containers.forEach(container => {
            const swiper = container.querySelector(".swiper");
            const prev = container.querySelector(".prev");
            const next = container.querySelector(".next");
            // Trouver l'élément de pagination
            const paginationEl = container.querySelector('.popin-pagination');
            const popinFooter = container.querySelector('.popin-footer');
            const popinHeaderH2All = container.querySelectorAll('.popin-header h2');

            // Vérifier que l'élément de pagination existe
            if (!paginationEl) {
                console.warn('Élément de pagination non trouvé pour le conteneur', container.id);
            }

            const swiperInstance = new Swiper(swiper, {
                loop: false,
                grabCursor: true,
                slidesPerView: 1,
                speed: 500,
                spaceBetween: "4%",
                modules: [Navigation, Pagination],
                navigation: {
                    prevEl: prev,
                    nextEl: next,
                },
                pagination: {
                    // Utilisez le sélecteur spécifique avec la classe popin-pagination
                    el: paginationEl,
                    type: 'fraction',
                    formatFractionCurrent: function (number) {
                        return number;
                    },
                    formatFractionTotal: function (number) {
                        return number;
                    },
                    renderFraction: function (currentClass, totalClass) {
                        return '<span class="' + currentClass + '"></span>' +
                            '<span class="separator"> | </span>' +
                            '<span class="' + totalClass + '"></span>';
                    },
                },
                on: {
                    init: (swiper) => {
                        console.log('Swiper initialized for', container.id, 'with', swiper.slides.length, 'slides');

                        // Marquer les sliders à une seule slide
                        if (swiper.slides.length <= 1) {
                            if (prev) prev.style.display = 'none';
                            if (next) next.style.display = 'none';
                            // Masquer également la pagination si un seul slide
                            if (paginationEl) {
                                paginationEl.style.display = 'none';
                            }
                            // masquer le popin footer si un seul slide
                            if (popinFooter) {
                                popinFooter.style.display = 'none';
                            }
                            // masquer tous les h2 du header si un seul slide
                            if (popinHeaderH2All && popinHeaderH2All.length > 0) {
                                popinHeaderH2All.forEach(h2 => {
                                    h2.style.display = 'none';
                                });
                            }
                        } else {
                            // Assurez-vous que la pagination est visible si plus d'un slide
                            if (paginationEl) {
                                paginationEl.style.display = 'flex';
                            }
                        }

                        // Met à jour le header au chargement initial
                        this.updatePopinHeader(container, swiper.realIndex);
                    },
                    slideChange: (swiper) => {
                        // Met à jour le header à chaque changement de slide
                        this.updatePopinHeader(container, swiper.realIndex);
                    },
                }
            });

            this.sliders.push(swiperInstance);
        });
    }
}